module.exports = __webpack_public_path__ + "media/images/icons/outlined/insert-row-above-1617510ab7f262c431935e0731c2eb3d.svg";